export default __webpack_public_path__ + "static/media/salami.2bda1834.png";